// React Imports
import React, { useState, useEffect, Fragment, useMemo } from "react";
import "./styles.css";
import { useForm, Controller } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as MagilhubIcon } from "common/assets/svg/magilhub_logo.svg";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import SignupPopup from "components/prompts/signupPopup";

import DialCodePicker from "components/dialCodePicker";
import { CountryCodeData } from "components/dialCodePicker/index";
import { getCountryRequest } from "common/features/auth/AuthActions";
import { ReactComponent as Showpassword } from "common/assets/svg/showPassword.svg";
import { ReactComponent as Hidepassword } from "common/assets/svg/hidePassword.svg";
import { SignInForm } from "common/features/auth/AuthModels";
import { validateField } from "common/utils/field-validator";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import {
  clearLocationAfterAuth,
  clearResetPassword,
  signIn,
  deletesignInData,
} from "common/features/auth/AuthActions";
import { getPlaceOrderURL, getMerchantHomeURL } from "common/utils/route-util";
import { GUEST_CART } from "common/constants";
// import GuestPopup from "components/prompts/guestPopup";
import ForgotPopup from "components/prompts/forgotPopup";
import ResetPasswordPrompt from "components/prompts/resetPasswordPrompt";
export interface guestCart {
  restaurantSlug: string;
  isPendingCart: boolean;
}
function PopupSign(props: any) {
  const history = useHistory();
  const dispatch = useDispatch();
  const authState = useSelector((state: RootState) => state.auth);
  const cart = useSelector((state: RootState) => state.cart);
  const toLocationAfterAuth = useSelector(
    (state: RootState) => state.auth.toLocationAfterAuth
  );
  const [userId, setUserId] = useState("");
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);
  const countryCode = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );
  const [resetPasswordPopup, setResetPasswordPopup] = useState(false);
  const setResetPasswordOpen = (set: boolean) => {
    if (set) {
      setResetPasswordPopup(false);
    }
  };

  // const [countryData, setCountryData] = useState<CountryCodeData>({
  //   code: "+91",
  //   flag: "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
  // });

  const [countryData, setCountryData] = useState<CountryCodeData>({
    code: "+1",
    flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
  });
  const [isMobile, setIsMobile] = useState(false);

  const {
    register,
    errors,
    handleSubmit,
    control,
    getValues,
    setValue,
    watch,
    formState,
  } = useForm<SignInForm>({
    defaultValues: {
      userId: "",
      password: "",
    },
  });
  const { isSubmitted } = formState;
  const setIsOpen = (set: boolean) => {
    if (set) {
      setloginRequestPopup(false);
    }
  };

  const setGuestOpen = (set: boolean) => {
    if (set) {
      setloginGuestPopup(false);
    }
  };

  const setForgotOpen = (set: boolean) => {
    if (set) {
      setforgotpasswordPopup(false);
    }
  };

  const cartURL = useSelector((state: RootState) => state.cart.cartURL);

  useEffect(() => {
    dispatch(getCountryRequest());
  }, []);

  // const countryCode = useSelector((state: RootState) => state.auth.countryCode);
  useEffect(() => {
    if (!authState.signInLoading && authState.signedIn && isSubmitted) {
      props.onClose(true);
    }
  }, [authState.signInLoading]);

  useEffect(() => {
    if (!authState.signInLoading && !authState.signedIn && isSubmitted) {
      setFormErrorMessage(authState.signInMessage);
    }
  }, [authState]);

  useEffect(() => {
    if (!authState.signInLoading && authState.signedIn) {
      console.log("Hello Called :::::::");

      //   history.push("/");
      localStorage.removeItem(GUEST_CART);
    }
    dispatch(clearResetPassword());
    dispatch(deletesignInData());
  }, []);

  const [loginRequestPopup, setloginRequestPopup] = useState(false);
  const [loginGuestPopup, setloginGuestPopup] = useState(false);
  const [loginForgotPopup, setforgotpasswordPopup] = useState(false);

  const onSubmit = (data: SignInForm) => {
    if (isMobile) {
      data.userId = countryData.code + "-" + data.userId;
    }
    dispatch(signIn(data));
  };

  const guestCart = localStorage.getItem(GUEST_CART);

  const hideLogo = useMemo(() => {
    return !toLocationAfterAuth.includes("table") && guestCart;
  }, [guestCart, toLocationAfterAuth]);

  const isDineInOrderAuth = toLocationAfterAuth.includes("table");

  const ColoredLine = ({ color }: any) => (
    <hr
      style={{
        color,
        backgroundColor: "#E0E0E0",
        height: 1,
        width: 350,
        marginTop: 10,
      }}
    />
  );
  const cartUrl = useSelector((state: RootState) => state.cart.cartURL);

  return (
    <Fragment>
      <SignupPopup
        isOpen={loginRequestPopup}
        visible={setIsOpen}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this promocode."}
        cartUrl={cartUrl}
      />

      {/* <GuestPopup
        isOpen={loginGuestPopup}
        visible={setGuestOpen}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this promocode."}
        cartUrl={cartUrl}
      /> */}

      <ForgotPopup
        isOpen={loginForgotPopup}
        visible={setForgotOpen}
        otpViewLogin={false}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this promocode."}
        cartUrl={cartUrl}
        resetPasswordPopup={resetPasswordPopup}
        setResetPasswordPopup={setResetPasswordPopup}
      />
      <ResetPasswordPrompt
        isOpen={resetPasswordPopup}
        visible={setResetPasswordOpen}
      />
      <DialCodePicker
        showPicker={showDialCodePicker}
        setShowPicker={setShowDialCodePicker}
        setCountryData={setCountryData}
        inputValue={userId}
        setIsMobile={setIsMobile}
        onlyMobile={false}
      />
      <div id="sign-in-screen" className={showDialCodePicker ? "dim" : ""}>
        {hideLogo ? (
          <span id="signIn-return-back">
            <BackIcon
              onClick={() => {
                dispatch(clearResetPassword());
                history.goBack();
                localStorage.removeItem(GUEST_CART);
              }}
              className="signIn-BackIcon"
            />
          </span>
        ) : (
          <React.Fragment>
            {isDineInOrderAuth && (
              <span
                style={{
                  padding: "0.8rem",
                  textAlign: "center",
                }}
              >
                Login to your account to receive loyalty points
              </span>
            )}
          </React.Fragment>
        )}

        <div>
          <ColoredLine color="#DCDCDC" />
        </div>
        <div className="login-prompt-logo-container">
          <MagilhubIcon />
          <span className="magilhub-logo">Magilhub</span>
        </div>
        <form id="sign-in-form" onSubmit={handleSubmit(onSubmit)}>
          <div id="text-box-container" style={{ marginTop: "1rem" }}>
            {/* User ID */}
            <label className="input-label">User ID</label>
            <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
              {/* {isMobile ? ( */}
              {true ? (
                <Fragment>
                  <img
                    alt="flag"
                    src={countryData.flag}
                    height={"14px"}
                    width={"21px"}
                    className="flag"
                    onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                  />
                  &nbsp;
                  <span
                    className="countryCode"
                    onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                  >
                    {countryData.code}
                  </span>
                </Fragment>
              ) : null}
              <input
                style={{ fontSize: 13 }}
                type="number"
                placeholder="Enter Mobile number"
                name="userId"
                ref={register(validateField("userID").isRequired().Rules)}
                onChange={(text) => {
                  setUserId(text.target.value);
                }}
                autoComplete="off"
              />
            </div>
            <span id="error-msg">
              {errors.userId && errors.userId.type === "required" && (
                <span className="req-msg">User ID Required</span>
              )}
            </span>
          </div>

          <div id="text-box-container" style={{ marginTop: "1rem" }}>
            {/* Password */}
            <label className="input-label">Password</label>
            <div id="signIn-text-box">
              <input
                style={{ fontSize: 13 }}
                className="pwd"
                type={isPasswordShown ? "text" : "password"}
                name="password"
                placeholder="Enter password"
                autoComplete="off"
                ref={register(validateField("password").isRequired().Rules)}
              />
              {isPasswordShown ? (
                <Hidepassword
                  className="hidePasswordSVG"
                  onClick={() => {
                    setIsPasswordShown(!isPasswordShown);
                  }}
                />
              ) : (
                <Showpassword
                  className="showPasswordSVG"
                  onClick={() => {
                    setIsPasswordShown(!isPasswordShown);
                  }}
                />
              )}
            </div>
            <span id="error-msg">
              {errors.password && errors.password.type === "required" && (
                <span className="req-msg">Password Required</span>
              )}
            </span>
          </div>

          <div id="links-container">
            {/* <span
              id="signIn-forgot-password-link-c"
              // onClick={() => {
              //     history.push("/resetpassword/userId");
              // }}
              onClick={() => {
                setforgotpasswordPopup(true);
              }}
              style={{ marginTop: "0", marginBottom: "0" }}
            >
              Forgot Password
            </span> */}

            <span
              className="sign-up-form-error-msg desktop-login-form-error-msg"
              style={{ marginBottom: "15px", width: "305px" }}
            >
              {formErrorMessage ? formErrorMessage : null}
            </span>

            <button
              id="sign-in-button"
              type="submit"
              onClick={() => {
                // console.log(errors);
              }}
              style={{ width: 305 }}
            >
              {authState.signInLoading ? "Signing In" : "Sign in"}
            </button>
            <div id="register-link">
              <span>Don't have an account?</span>
              &nbsp;
              <span
                id="create-new-account"
                onClick={() => {
                  //setloginRequestPopup(true);
                  props?.openSignUpPopoup(true)
                }}
              >
                Create New Account
              </span>
            </div>

            {props.openGuestPopup && (
              <div
                id="register-link"
                style={{ marginTop: "8px", marginBottom: "16px" }}
              >
                {/* <span>Don't have an account?</span> */}
                &nbsp;
                <span
                  id="create-new-account"
                  onClick={() => {
                    props.openGuestPopup(true);

                    // props.onClose(true)
                  }}
                >
                  Continue as a guest
                </span>
              </div>
            )}
            {/* <div className="login-prompt-logo-container">
              <span className="login-prompt-logo-text">Powered by {"  "} </span>
              <div>
                <MagilhubIcon />
                <span className="magilhub-logo">Magilhub</span>
              </div>
            </div> */}
          </div>
        </form>
      </div>
    </Fragment>
  );
}

export default PopupSign;
